import { useKeyboard } from '../../../shared/hooks/useKeyboard';
import { useDispatch } from 'react-redux';
import { copyCurrentDiagnostic } from '../thunks/copy-current-diagnostic.thunk';
import { DateTime } from 'luxon';
import { useRef } from 'react';

export const useCopyDiagnostic = (
  copyDiagnosticThunk = copyCurrentDiagnostic,
) => {
  const dispatch = useDispatch();
  const delta = 500;
  const lastKeypressTime = useRef(0);

  useKeyboard('keyup', 'c', () => {
    const thisKeypressTime = DateTime.now().toMillis();

    if (thisKeypressTime - lastKeypressTime.current < delta) {
      dispatch(copyDiagnosticThunk());
    }
    lastKeypressTime.current = thisKeypressTime;
  });
};
